'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./kleber/kleberAddressSearch'));
    processInclude(require('./kleber/kleberAddressRepair'));
    processInclude(require('./kleber/kleberEmailValidation'));
    processInclude(require('./kleber/kleberCommon'));
});
